import Vue from 'vue';
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

interface MessageDefinition {
  [kex: string]: {
    [key: string]: string
  }
}

const messageDefinition: MessageDefinition = {
  already_existed_depots: {
    de: 'Existierende Depots',
    en: 'Existing depots'
  },
  already_existed_depots_tooltip: {
    de: 'Anzahl an Depots, die bereits vor der OCT-Nutzung existierten und die erfolgreich mit einem OCT-Konto verbunden wurden oder für die eine Verbindungs-Anfrage gestellt wurde.',
    en: 'Number of depots which already existed before using OCT and either are connected it to an OCT-account successfully or for which a connection request is available.'
  },
  connected_depots: {
    de: 'Verbundene Depots',
    en: 'Connected depots'
  },
  connected_depots_tooltip: {
    de: 'Anzahl an Depots, die erfolgreich mit einem OCT-Konto verbunden sind und die daher in OCT zum Handeln verwendet können.',
    en: 'Number of depots which are successfully connected to an OCT-account.'
  },
  connection_requested: {
    de: 'Depotverbindung angefragt',
    en: 'Requested depot connection'
  },
  connection_requested_tooltip: {
    de: 'Anzahl an Depots, für die eine Verbindung mit einem OCT-Konto angefragt ist.',
    en: 'Number of depots for which a connection with an OCT-account was requested.'
  },
  declined_depots: {
    de: 'Abgelehnte Depotverbindungen',
    en: 'Declined depot connections'
  },
  declined_depots_tooltip: {
    de: 'Anzahl an Depots, für die eine Verbindungsanfrage mit einem OCT-Konto final abgelehnt wurde.',
    en: 'Number of depots for which a connection request with an OCT-account has been declined.'
  },
  depots_in_creation: {
    de: 'Gewünschte Depot-Neueröffnungen',
    en: 'Requested new depots'
  },
  depots_in_creation_tooltip: {
    de: 'Anzahl an OCT-Nutzern, die zur Depot-Eröffnung auf Ihre Webseite weitergeleitet wurden.',
    en: 'Number of OCT-users forwarded to the depot creation form on your website.'
  },
  depot_owner_prop_firstName: {
    de: 'Vorname',
    en: 'First Name'
  },
  depot_owner_prop_lastName: {
    de: 'Nachname',
    en: 'Last Name'
  },
  depot_owner_prop_zipcode: {
    de: 'Postleitzahl',
    en: 'Zip Code'
  },
  depot_owner_prop_city: {
    de: 'Stadt',
    en: 'City'
  },
  depot_owner_prop_street: {
    de: 'Straße',
    en: 'Street'
  },
  depot_prop_phone: {
    de: 'Telefonnummer',
    en: 'Phone number'
  },
  depot_owner_prop_countryCode: {
    de: 'Land',
    en: 'Country'
  },
  depot_prop_email: {
    de: 'E-Mail',
    en: 'e-mail',
  },
  depot_prop_firstName: {
    de: 'Vorname',
    en: 'first name',
  },
  depot_prop_lastName: {
    de: 'Nachname',
    en: 'last name',
  },
  depot_prop_lastInteraction: {
    de: 'Letztes Update',
    en: 'Last Update',
  },
  depot_prop_status: {
    de: 'Verbindungsstatus',
    en: 'Connection state'
  },
  depot_prop_number: {
    de: 'Depotnummer',
    en: 'Account Number'
  },
  depot_search: {
    de: 'Depotsuche',
    en: 'Depot Search'
  },
  depot_search_hint: {
    de: 'Mindestens 3 Zeichen eingeben',
    en: 'At least 3 characters'
  },
  depot_search_label: {
    de: 'Depotnummer, E-Mail Adresse, Vor- oder Nachname eingeben',
    en: 'Enter an account number, email address, a first name or a last name'
  },
  depot_status_connected: {
    de: 'Verbunden',
    en: 'Connected'
  },
  depot_status_created: {
    de: 'in Neueröffnung',
    en: 'in Creation'
  },
  depot_status_declined: {
    de: 'Abgelehnt',
    en: 'Declined'
  },
  depot_status_invalid: {
    de: 'Ungültig',
    en: 'Invalid'
  },
  depot_status_pending: {
    de: 'Angefragt',
    en: 'Requested'
  },
  last_viewed_depots: {
    de: 'Zuletzt angezeigte Depots',
    en: 'Recent depots'
  },
  link_requests_title: {
    de: 'Verbindungsanfragen',
    en: 'Connection Requests'
  },
  ACCOUNT_CREATED: {
    de: 'Weitergeleitet zur Depoteröffnung',
    en: 'Forwarded to Depot Creation'
  },
  CONNECTION_REQUESTED: {
    de: 'Verbindungsanfrage gestellt',
    en: 'Connection requested'
  },
  REQUEST_DECLINED: {
    de: 'Verbindungsanfrage abgelehnt',
    en: 'Connection request declined'
  },
  REQUEST_ACCEPTED: {
    de: 'Verbindungsanfrage akzeptiert',
    en: 'Connection request accepted'
  },
  INVALID_ADDRESS: {
    de: 'Ungültige Adresse festgestellt',
    en: 'Invalid address detected'
  },
  INVALID_NAME: {
    de: 'Ungültiger Name festgestellt',
    en: 'Invalid name detected'
  },
  INVALID_ACCOUNT: {
    de: 'Ungültiges Konto festgestellt',
    en: 'Invalid account detected'
  },
  INVALID_STATE: {
    de: 'Ungültiges Konto festgestellt',
    en: 'Invalid account detected'
  },
  INVALID_ADDRESS_label: {
    de: 'Adresse',
    en: 'Address'
  },
  INVALID_NAME_label: {
    de: 'Name',
    en: 'Name'
  },
  INVALID_ACCOUNT_label: {
    de: 'Konto',
    en: 'Account'
  },
  INVALID_STATE_label: {
    de: 'State',
    en: 'State'
  },
  language: {
    de:'Sprache',
    en: 'Language'
  },
  language_de: {
    de:'Deutsch',
    en: 'German'
  },
  language_en: {
    de:'Englisch',
    en: 'English'
  },
  newly_created_depots: {
    de: 'Neu angelegte Depots',
    en: 'Newly created depots'
  },
  newly_created_depots_tooltip: {
    de: 'Anzahl an Depots, die wegen OCT eröffnet wurden und im Anschluss erfolgreich mit ihrem OCT-Konto verbunden wurden oder bereits eine Anfrage dazu gestellt haben.',
    en: 'Number of depots which were initiated by OCT and have connected the newly opened depot successfully to OCT afterwards or have already submitted a request to do so.'
  },
  one_click_trading: {
    de: 'One Click Trading',
    en: 'One Click Trading'
  },
  orders_title: {
    de: 'Übermittelte Orders',
    en: 'Transmitted orders'
  },
  order_prop_status: {
    de: 'Status',
    en: 'Status'
  },
  order_prop_clientTimestamp: {
    de: 'Datum',
    en: 'Date'
  },
  order_prop_symbol: {
    de: 'Symbol (ISIN / WKN)',
    en: 'Symbol (ISIN / WKN)'
  },
  order_prop_longName: {
    de: 'Beschreibung',
    en: 'Description'
  },
  order_prop_marketPlace: {
    de: 'Marktplatz',
    en: 'Marketplace'
  },
  order_prop_contractCount: {
    de: 'Anzahl',
    en: 'Count'
  },
  order_prop_assetType: {
    de: 'Asset type',
    en: 'Asset type'
  },
  order_prop_currency: {
    de: 'Währung',
    en: 'Currency'
  },
  order_prop_type: {
    de: 'Typ',
    en: 'Type'
  },
  order_prop_errorDescription: {
    de: 'Nachricht',
    en: 'Message'
  },
  PHONENUMBER_INFO: {
    de: 'Der Benutzer hat zugestimmt, dass Sie ihn im Zuge der Kontoeröffnung unter der Telefonnummer \'{phone}\' anrufen dürfen.',
    en: 'The user has agreed that you can call them on \'{phone}\' to support them while opening the account'
  },
  broker_setting: {
    de: 'Broker',
    en: 'Broker'
  },
  invalid_requests: {
    de: 'Ungültige Anfragen',
    en: 'Invalid Requests'
  },
  invalid_requests_tooltip: {
    de: 'Anzahl an Depots, deren Verbindungsanfragen aufgrund ungültiger oder unvollständiger Informationen vorerst abgelehnt wurden.',
    en: 'Number of depots whose connection requests were rejected for now due to invalid or missing information.'
  },
  export_dialog_title: {
    de: 'Daten exportieren',
    en: 'Export data'
  },
  export_dialog_fromDate: {
    de: 'Start-Datum',
    en: 'Start date'
  },
  export_dialog_toDate: {
    de: 'End-Datum',
    en: 'End date'
  },
  export_dialog_fieldDelimiter: {
    de: 'Zellen-Trennzeichen',
    en: 'Cell delimiter'
  },
  export_dialog_lineDelimiter: {
    de: 'Zeilenumbruch',
    en: 'Linebreak'
  },
  export_dialog_error_no_data: {
    de: 'Keine Daten in angegebenen Zeitraum gefunden!',
    en: 'No data in selected range found!'
  },
  invalid: {
    de: 'Ungültige Daten',
    en: 'Invalid data',
  },
  accept: {
    de: 'Akzeptieren',
    en: 'Accept',
  },
  decline: {
    de: 'Ablehnen',
    en: 'Decline',
  },
  edit_accountnumber: {
    de: 'Depotnummer bearbeiten',
    en: 'Edit account number',
  },
  edit_accountnumber_dialog_title: {
    de: 'Depotnummer editieren',
    en: 'Edit account number'
  },
  edit_accountnumber_dialog_save: {
    de: 'Speichern',
    en: 'Save'
  },
  edit_accountnumber_dialog_cancel: {
    de: 'Abbrechen',
    en: 'Cancel'
  },
  edit_accountnumber_dialog_textfield_label: {
    de: 'Depotnummer',
    en: 'Account number'
  },
  edit_accountnumber_disabled: {
    de: 'Der Benutzer hat die Verbindungsanfrage abgebrochen oder die Verbindungsanfrage wurde abgelehnt. Eine Änderung der Depotnummer ist nicht mehr möglich.',
    en: 'The user canceled the link-request. Changing the account number is not possible anymore.'
  }
};

let messages: MessageDefinition = {
  de: {},
  en: {}
};

for( let prop in messageDefinition ) {
  for( let lang in messageDefinition[prop] ) {
    messages[lang][prop] = messageDefinition[prop][lang];
  }
}

export const i18n = new VueI18n({
  locale: 'de', fallbackLocale: 'en', messages: messages
});
